import {
  Grid,
  InfoIcon,
  Select,
  SelectVariant,
  Text,
  TextSize,
  TextWeight,
  TooltipPlacement
} from '@focaldata/cin-ui-components'
import React from 'react'
import { AudiencePreset } from '../../../hooks/audience/usePresetAudience'
import { isDemoUser } from '../../../utils/authUtils'
import { getPresetsSelectItems } from '../utils'

interface Props {
  presets: AudiencePreset[]
  selectedPresetName?: string
  isSelectedPresetWeighted?: boolean
  onPresetChosen?: (newAudiencePreset: AudiencePreset) => void
  disabled?: boolean
}

const AudiencePresetSelect: React.FC<Props> = (props: Props) => {
  const {
    presets,
    selectedPresetName,
    isSelectedPresetWeighted,
    onPresetChosen,
    disabled
  }: Props = props
  const newOptions = getPresetsSelectItems(presets)

  React.useEffect(() => {
    if (isDemoUser()) {
      const preset = presets.find((pr) => pr.name === selectedPresetName)

      if (preset && onPresetChosen) {
        onPresetChosen(preset)
      }
    }
  }, [onPresetChosen, presets, selectedPresetName])

  const handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void = (
    event
  ) => {
    if (disabled) return

    const preset = presets.find(
      (pr) => pr.presetAudienceId === event.target.value
    )
    if (preset && onPresetChosen) {
      onPresetChosen(preset)
    }
  }

  return (
    <>
      <Grid container direction="row" alignItems="center">
        <Grid item xs="auto">
          <Text size={TextSize.m} weight={TextWeight.SemiBold}>
            Audience
          </Text>
        </Grid>
        <Grid item xs="auto">
          <InfoIcon
            tooltipPlacement={TooltipPlacement.Top}
            text={
              isDemoUser()
                ? 'Complex audiences available on request'
                : "Select one of our preset audiences. Then make any changes in the editor. Or start from scratch with a custom audience. Please email support@focaldata.com if you need help setting up your audience or want to add other preset audiences to the list. We'll respond immediately. "
            }
          />
        </Grid>
      </Grid>
      <Grid item xs="auto">
        <Select
          ariaLabel="Audience preset select"
          variant={SelectVariant.Filled}
          defaultOptionValue={selectedPresetName}
          optionValue={selectedPresetName}
          maxMenuHeight={300}
          optionSuffix={isSelectedPresetWeighted ? 'Weighted' : undefined}
          options={newOptions}
          onChange={handleChange}
          fullWidth
          disabled={disabled}
          readOnly={disabled}
        />
      </Grid>
    </>
  )
}

export default AudiencePresetSelect
